import { Injectable } from '@angular/core';

import {
  BusinessChatService,
  FacebookService,
  GmbService,
  Instagram2Service,
  KakaotalkService,
  LineService,
  LinkedinService,
  TiktokService,
  TrustpilotService,
  TwitterService,
  WebchatService,
  WhatsappService,
} from './channels';
import { StrategyAbstractService } from './strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class StrategiesService {
  strategiesMap: Map<number, StrategyAbstractService> = new Map();

  private all: StrategyAbstractService[];

  constructor(
    private businessChatService: BusinessChatService,
    private facebookService: FacebookService,
    private gmbService: GmbService,
    private instagram2Service: Instagram2Service,
    private kakaotalkService: KakaotalkService,
    private lineService: LineService,
    private linkedinService: LinkedinService,
    private tiktokService: TiktokService,
    private trustpilotService: TrustpilotService,
    private twitterService: TwitterService,
    private webchatService: WebchatService,
    private whatsappService: WhatsappService
  ) {
    //order is important, determines diplay in inbox
    this.all = [
      this.facebookService,
      this.whatsappService,
      this.instagram2Service,
      this.twitterService,
      this.webchatService,
      this.businessChatService,
      this.gmbService,
      this.lineService,
      this.kakaotalkService,
      this.trustpilotService,
      this.linkedinService,
      this.tiktokService,
    ];
    if (!this.strategiesMap.size) {
      this.all.forEach(strategy => this.strategiesMap.set(strategy.getType(), strategy));
    }
  }

  getAll(): StrategyAbstractService[] {
    return this.all;
  }

  getStrategy(strategy: string): StrategyAbstractService {
    return this.all.filter(s => s.getTypeString() === strategy)[0];
  }

  getStrategyFromType(type: number): StrategyAbstractService {
    return this.all.filter(s => s.getType() === type)[0];
  }

  getOrderedSiteTypeStrings(): string[] {
    return this.all.map(strategy => strategy.getTypeString());
  }
}
